export default function CsharpMathClass() {
  return (
    <h2>Csharp Math Class</h2>
  );
}
